const SvgAlignCenterSvgrepoCom = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2a1 1 0 0 1 0-2h16a1 1 0 1 1 0 2H1zm3 4a1 1 0 0 1 0-2h11a1 1 0 1 1 0 2H4zm-1 4a1 1 0 1 1 0-2h13a1 1 0 1 1 0 2H3zm-2 4a1 1 0 1 1 0-2h16a1 1 0 1 1 0 2H1zm3 4a1 1 0 1 1 0-2h11a1 1 0 1 1 0 2H4z"
      fill="#9B9B9B"
    />
  </svg>
);

export default SvgAlignCenterSvgrepoCom;
